import React, { useState, useEffect } from 'react';
import '../../app/App.css';
import './Home.css';
import Grid from '@mui/material/Grid';
import { Link } from 'react-router-dom';
import apiService from '../../services/apiServices';

function Home() {
  const [workers, setWorkers] = useState();
  const [salaries, setSalaries] = useState();
  const [contracts, setContracts] = useState();
  const [holidays, setHolidays] = useState();

  useEffect(() => {
    apiService().get('workers').then((response) => {
        if (response.success) {
          setWorkers(response.data);
        }  
      });

      apiService().get('salariesmonthlylists').then((response) => {
          if (response.success) {
              let products = response.data;
              setSalaries(products);
          }
      });

      apiService().get('workerContract').then((response) => {
        if (response.success) {
            let products = response.data;
            setContracts(products);
        }  
    });

    apiService().get('holidays').then((response) => {
      if (response.success) {
        setHolidays(response.data);
      } 
    });
  }, []);

  return (
    <div className="container">
      {/* <main className="wrapper">
        <Grid item xs={12}>
          <Grid container justifyContent="center" spacing={5}>
            <Grid item xs={10} sm={4} lg={2}>
              <Link to="/workerlist">
                <div className="button-container">
                  <div className="box-btn box-red">
                    <div className="text-wrapper yellow-position-fix">
                      Regjistrimi i punetorve
                    </div>
                  </div>
                </div>
              </Link>
            </Grid>
            <Grid item xs={10} sm={4} lg={2}>
              <Link to="/salarieslist">
                <div className="button-container">
                  <div className="box-btn box-red">
                    <div className="text-wrapper">Lista e pagave</div>
                  </div>
                </div>
              </Link>
            </Grid>
            <Grid item xs={10} sm={4} lg={2}>
              <Link to="/contractlist">
                <div className="button-container">
                  <div className="box-btn box-green">
                    <div className="text-wrapper">Kontratat</div>
                  </div>
                </div>
              </Link>
            </Grid>
            <Grid item xs={10} sm={4} lg={2}>
              <Link to="/home/contracts">
                <div className="button-container">
                  <div className="box-btn box-yellow">
                    <div className="text-wrapper yellow-position-fix">
                      Menaxhimi i pushimeve
                    </div>
                  </div>
                </div>
              </Link>
            </Grid>
            <Grid item xs={10} sm={4} lg={2}>
              <Link to="/home/reports">
                <div className="button-container">
                  <div className="box-btn box-blue">
                    <div className="text-wrapper">Raportet</div>
                  </div>
                </div>
              </Link>
            </Grid>
          </Grid>
        </Grid>
      </main> */}

      <Grid container spacing={2} sx={{ m: 0 }}>
        <Grid item xs={10} sm={4} lg={3}>
          <Link to="/workerlist">
            <div className="card card-1">
              <h3>Regjistrimi i punetorve</h3>
              <h1>{workers?.length > 0 ? workers?.length : '0'}</h1>
            </div>
          </Link>
        </Grid>
        <Grid item xs={10} sm={4} lg={3}>
          <Link to="/salarieslist">
            <div className="card card-2">
              <h3>Lista e pagave</h3>
              <h1>{salaries?.length > 0 ? salaries?.length : '0'}</h1>
            </div>
          </Link>
        </Grid>
        <Grid item xs={10} sm={4} lg={3}>
          <Link to="/contractlist">
            <div className="card card-3">
              <h3>Kontratat</h3>
              <h1>{contracts?.length > 0 ? contracts?.length : '0'}</h1>
            </div>
          </Link>
        </Grid>
        <Grid item xs={10} sm={4} lg={3}>
          <Link to="/holidays">
            <div className="card card-4">
              <h3>Menaxhimi i pushimeve</h3>
              <h1>{holidays?.length > 0 ? holidays?.length : '0'}</h1>
            </div>
          </Link>
        </Grid>
        <Grid item xs={10} sm={4} lg={3}>
          <Link to="/home/reports">
            <div className="card card-5">
              <h3>Raportet</h3>
              <h1>0</h1>
            </div>
          </Link>
        </Grid>
      </Grid>
    </div>
  );
}
export default Home;
